import React from 'react';
import styled, { css } from 'styled-components';

import TEST_ID from './index.testid';
import { Label } from '~/components/atom/Typography';

export type Props = {
  filteredItemsCount: number;
  totalContactsInAccount: number;
  selectedContactAmount: number;
};

const text = {
  contactCreatedToastTemplate: (name: string): string =>
    `Nieuw contact "${name}" toegevoegd!`,
  contactAmount: (amount: number) =>
    `${amount} ${amount === 1 ? 'contact' : 'contacten'}`,
};

const TableTotalAmountContainer: React.FCC<Props> = ({
  filteredItemsCount,
  totalContactsInAccount,
  selectedContactAmount,
}) => {
  const amountText = `Toont ${filteredItemsCount} van ${text.contactAmount(totalContactsInAccount)} |`;
  const selectedAmountText = ` ${text.contactAmount(selectedContactAmount)} geselecteerd`;

  return (
    <Container data-testid={TEST_ID.CONTAINER}>
      <Label inline margin={[null]}>
        {amountText}
      </Label>
      <Label inline data-testid={TEST_ID.SELECTED_ITEMS_TEXT} margin={[null]}>
        {selectedAmountText}
      </Label>
    </Container>
  );
};

const Container = styled.div<{}>(
  ({ theme }) => css`
    font-weight: ${theme.fw('medium')};
    margin: ${theme.space('m')} 0 ${theme.space('xxs')};
  `,
);

export default TableTotalAmountContainer;
